<template>
  <table class="orders-table">
    <tr>
      <th
        colspan="8"
        class="header"
      >
        Orders
      </th>
    </tr>
    <tr>
      <th>Segment ID</th>
      <th>Sup order ref</th>
      <th>Sup order ID</th>
      <th>Price over Time</th>
      <th>Property</th>
      <th>CXL Start</th>
      <th>Status</th>
      <th>Total</th>
    </tr>
    <rw-orders-table-row
      v-for="(row) in rows"
      :key="`row-${row.segmentId}-${row.supOrderId}`"
      :segment-id="row.segmentId"
      :sup-order-ref="row.supOrderRef"
      :sup-order-id="row.supOrderId"
      :creation-date-property="row.creationDateProperty"
      :cxl-start="row.cxlStart"
      :status="row.status"
      :total-amount="row.totalAmount"
      :currency="row.currency"
      :sb-rb-currency="row.sbRbCurrency"
      :hotel-name="row.hotelName"
      :hotel-address="row.hotelAddress"
      :image-url="row.hotelImage"
      :order-num="row.orderNum"
      :hotel-country-code="row.hotelCountryCode"
      :hotel-destination="row.hotelDestination"
      :star-rating="row.star"
      :check-in-date="row.checkInDate"
      :check-out-date="row.checkOutDate"
      :supplier="row.supplier"
      :payment="row.payment"
      :cancelation-policy="row.cancelationPolicy"
      :smartbook="row.smartbook"
      :rebooker="row.rebooker"
      :cancellation-policy="row.cancellationPolicy"
    />
  </table>
</template>

<script>
import RwOrdersTableRow from './RwOrdersTableRow';

export default {
  name: 'rw-orders-table',
  components: {
    RwOrdersTableRow,
  },
  props: {
    headers: {
      type: Array,
      default: null,
    },
    rows: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.orders-table {
  width: 100%;
  font-size: 12px;
  color: #6e7c91;
  box-shadow: 0 6px 24px 2px rgba(114, 132, 160, 0.18);
  border-radius: 3px;
  background-color: #fff;

  th {
    border: none;
    padding: 9px 18px;
    vertical-align: top;
    text-align: left;
    font-weight: 700;

    &.header {
      padding: 18px;
      text-align: left;
      font-size: 15px;
      font-weight: 700;
    }
  }
}
</style>
